<template>
  <div>
    <b-alert 
      :show="mailsent && current_id != 0"
      variant="success"
      dismissable
      @dismissed="mailsent = 0"
    >
      <span v-if="mailsent == 1">Password e-mail sent.</span>
      <span v-else-if="mailsent == 2">Welcome e-mail sent.</span>
    </b-alert>
    <h3 class="my-auto">
      <b-button @click.prevent="backtolist" variant="outline-primary">&lt; Return to list</b-button>
      <span v-if="consultant_id > 0" class="ml-4">{{consultant_id}} <span :class="`${anon ? 'g-anon' : '' }`">{{first_name}} {{family_name}}</span></span>
      <span v-if="consultant_id < 0" class="ml-4">Add User</span>
    </h3>
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="col-12 text-center">
            General Information
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <b-row>
            <form autocomplete=off @submit.stop.prevent>
            <div class="row">
              <div class="col-6">
                <b-form-group 
                  label-cols="4"
                  label="First name"
                  class="col-12"
                  invalid-feedback="First name cannot be blank"
                >
                  <b-form-input  
                    id="first_name" 
                    :state="first_name_valid"
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="first_name"
                    v-on:change="savefield('i_user',consultant_id,'first_name',first_name)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Family name"
                  class="col-12 mt-2"
                  invalid-feedback="Family name cannot be blank"
                >
                  <b-form-input  
                    id="family_name" 
                    :state="family_name_valid"
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="family_name"
                    v-on:change="savefield('i_user',consultant_id,'family_name',family_name)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Title"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="prefix_title" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="prefix_title"
                    v-on:change="savefield('g_profile',consultant_id,'prefix_title',prefix_title)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>                
                <b-form-group 
                  label-cols="4"
                  label="Company name"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="company_name" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="company_name"
                    v-on:change="savefield('g_profile',consultant_id,'company_name',company_name)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>                
                <b-form-group 
                  label-cols="4"
                  label="Address line 1"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="address_1" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="address_1"
                    v-on:change="savefield('g_profile',consultant_id,'address_1',address_1)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>                
                <b-form-group 
                  label-cols="4"
                  label="Address line 2"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="address_2" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="address_2"
                    v-on:change="savefield('g_profile',consultant_id,'address_2',address_2)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>                
                <b-form-group 
                  label-cols="4"
                  label="Zip code"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="zip_code" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="zip_code"
                    v-on:change="savefield('g_profile',consultant_id,'zip_code',zip_code)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>                
                <b-form-group 
                  label-cols="4"
                  label="City"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="city" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="city"
                    v-on:change="savefield('g_profile',consultant_id,'city',city)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>                

                <b-form-group 
                  label-cols="4"
                  label="E-mail"
                  :invalid-feedback="emailinvalidfeedback"
                  class="col-12 mt-2"
                >
                  <b-form-input  
                    id="email" 
                    :state="email_valid"
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="email"
                    v-on:change="checkemail();savefield('i_user',consultant_id,'email',email)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Telephone"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="telephone" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="telephone"
                    v-on:change="savefield('g_profile',consultant_id,'telephone',telephone)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Country"
                  class="col-12"
                  invalid-feedback="You must select a country"
                >
                  <b-form-select  
                    id="country_id" 
                    :state="country_id_valid"
                    class="form-control"
                    v-model="country_id"
                    :options="countries"
                    v-on:change="savefield('g_profile',consultant_id,'country_id',country_id)" 
                    autocomplete="off"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="URL"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="url" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="url"
                    v-on:change="savefield('g_profile',consultant_id,'url',url)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>                
                <b-form-group 
                  label-cols="4"
                  label="Affiliated Company"
                  class="col-12"
                  invalid-feedback="You must select a company"
                >
                  <b-form-select  
                    id="company_id" 
                    :state="company_id_valid"
                    class="form-control"
                    v-model="company_id"
                    :options="companies"
                    v-on:change="savefield('g_profile',consultant_id,'company_id',company_id)" 
                    autocomplete="off"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="VAT Number"
                  class="col-12 mt-2">
                  <b-form-input  
                    id="vat_number" 
                    class="form-control"
                    v-model="vat_number"
                    v-on:change="savefield('g_profile',consultant_id,'vat_number',vat_number)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Consultant group"
                  class="col-12"
                >
                  <b-form-select  
                    id="consultantgroup_id" 
                    :class="`form-control ${anon ? 'g-anon' : '' }`"
                    v-model="consultantgroup_id"
                    :options="consultantgroups"
                    v-on:change="savefield('g_profile',consultant_id,'consultantgroup_id',consultantgroup_id)" 
                    autocomplete="off"
                  >
                  </b-form-select>
                </b-form-group>                
                <b-form-group 
                  label-cols="4"
                  label="Partner"
                  class="col-12"
                >
                  <b-form-select  
                    id="partner_id" 
                    :state="partner_id_valid"
                    class="form-control"
                    v-model="partner_id"
                    :options="partners"
                    v-on:change="savefield('g_profile',consultant_id,'partner_id',partner_id)" 
                    autocomplete="off"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Consultant status"
                  class="col-12"
                >
                  <b-form-select  
                    id="consultantstatus_id" 
                    class="form-control"
                    v-model="consultantstatus_id"
                    :options="consultantstatuses"
                    v-on:change="savefield('g_profile',consultant_id,'consultantstatus_id',consultantstatus_id)" 
                    autocomplete="off"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Certified by"
                  class="col-12"
                >
                  <b-form-select  
                    id="certified_by" 
                    :state="certified_by_valid"
                    class="form-control col-7"
                    v-model="certified_by"
                    :options="tots"
                    v-on:change="savefield('g_profile',consultant_id,'certified_by',certified_by)" 
                    autocomplete="off"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Certification date"
                  class="col-12"
                >
                  <datetime
                    class="col-4 ml-0 pl-0 pr-0 mr-0"
                    type="date"
                    input-class="form-control col-9 gdq-w-150px"
                    v-on:input="savefield('g_profile',consultant_id,'certification_date',certification_date)"
                    format="yyyy-LL-dd"
                    v-model="certification_date"
                    :phrases="{ok: 'OK', cancel: 'Cancel'}"
                  >
                  </datetime>
                </b-form-group>
                <b-form-group 
                  label-cols="4"
                  label="Diploma Number" 
                  class="col-12 mt-2">
                  <b-form-input  
                    id="certificate_number" 
                    class="form-control col-7"
                    v-model="certificate_number"
                    v-on:change="savefield('g_profile',consultant_id,'certificate_number',certificate_number)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                  <b-button 
                    v-if="consultant_id!=-1 && !certificate_number"
                    @click.prevent="generate_certificate_number"
                  >
                    Generate
                  </b-button>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group 
                  label-cols="5"
                  label="User name"
                  class="col-12 mt-2"
                >
                  <b-form-input  
                    id="i_name" 
                    :class="`form-control mr-2 ${anon ? 'g-anon' : '' }`"
                    v-model="i_name"
                    v-on:change="savefield('i_user',consultant_id,'i_name',i_name)" 
                    autocomplete="off"
                  >
                  </b-form-input>
                  
                  <b-button 
                    v-if="consultant_id > 0" 
                    @click.prevent="setpassword(true)"
                    class="mt-1 gdq-w-200px"
                  >
                    <span class="icon-key mr-2"></span>Set password
                  </b-button>
                </b-form-group>
                <b-form-group
                  label-cols="5"
                  label="" v-if="settingpassword == true || consultant_id < 0" class="form-group col-12 mt-2">
                  <span v-if="consultant_id > 0" class="col-4 mx-0 px-0">Set Password</span>
                  <input type="text" style="display:none;">
                  <b-form-input  
                    type="text"
                    id="new_password" 
                    class="form-control gdq-w-200px"
                    v-model="newpassword"
                    autocomplete="off"
                  >
                  </b-form-input>
                  <b-button v-if="consultant_id > 0" variant="primary" @click.prevent="savepassword()" class="mr-2"><span class="icon-checkmark"></span></b-button>
                  <b-button v-if="consultant_id > 0" variant="danger" @click.prevent="setpassword(false)"><span class="icon-cross"></span></b-button>
                </b-form-group>
                <b-form-group label-cols="5">
                  <b-button 
                    v-if="consultant_id > 0" 
                    @click.prevent="sendpasswordlink" 
                    variant="outline-primary"
                    class="mt-1 gdq-w-200px"
                  >
                    <span class="icon-mail mr-2"></span>Send password link
                  </b-button>
                  <b-button 
                    v-if="consultant_id > 0" 
                    @click.prevent="sendwelcomeemail" 
                    variant="outline-primary"
                    class="mt-1 gdq-w-200px"
                  >
                    <span class="icon-mail mr-2"></span>Send welcome e-mail
                  </b-button>
                </b-form-group>
                <b-form-group class="ml-3" label="Require Two-factor login" label-cols="5">
                  <b-form-checkbox
                    v-model="i_2fa"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('i_user',consultant_id,'i_2fa',i_2fa)"
                  >
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Require Two-factor Email login" label-cols="5">
                  <b-form-checkbox
                    v-model="i_2fa_email"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('i_user',consultant_id,'i_2fa_email',i_2fa_email)"
                  >
                  </b-form-checkbox>
                </b-form-group>                
                <b-form-group 
                  label-cols="5"
                  label="Last activity"
                  class="col-12 mt-2"
                >
                  <div 
                    class="mt-2"
                  >
                    {{  last_login ? `Login: ${last_login.substring(0,10)}` : (certification_date ? `Certified: ${certification_date.substring(0,10)}` : '') }}
                    <span
                      v-if="gdq_recertification"
                    >
                    <b-badge

                      variant="danger"
                    >
                      Re-certify
                    </b-badge>
                  </span> 
                  </div>
                </b-form-group>
                <div class="col-12 row mt-2 ml-3 pl-0 align-items-top">
                  <div class="col-5 ml-0 pl-0 mx-0 px-0">User Groups</div>
                  <div class="px-0">
                    <div v-for="usergroup in usergroups" :key="usergroup.id">
                      <b-form-checkbox
                        v-model="i_usergroups"
                        :value="usergroup.id"
                        value-unchecked="0"
                        class="form-control border-0"
                        @input="saveusergroups"
                      >
                        {{ usergroup.name }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
                <b-form-group class="ml-3" label="Can use GDQ Short" label-cols="5">
                  <b-form-checkbox
                    v-model="gdq_short"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'gdq_short',gdq_short)"
                  >
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Can use OSC" label-cols="5">
                  <b-form-checkbox
                    v-model="osc"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'osc',osc)"
                  >
                  </b-form-checkbox>
                </b-form-group>            
                <b-form-group class="ml-3" label="Can use Aggregated Short" label-cols="5">
                  <b-form-checkbox
                    v-model="aggregated_reports"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'aggregated_reports',aggregated_reports)"
                  >
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Can use Aggregated Full" label-cols="5">
                  <b-form-checkbox
                    v-model="aggregated_full"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'aggregated_full',aggregated_full)"
                  >
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Is a Spotify Consultant" label-cols="5">
                  <b-form-checkbox
                    v-model="spotify"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'spotify',spotify)"
                  >
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Allow GDQ Demographics" label-cols="5">
                  <b-form-checkbox
                    v-model="allow_demographics"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'allow_demographics',allow_demographics)"
                  >
                </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Anonymize surveys when close" label-cols="5">
                  <b-form-checkbox
                    v-model="anonymize_survey_on_close"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'anonymize_survey_on_close',anonymize_survey_on_close)"
                  >
                </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Show consultant on GDQ web" label-cols="5">
                  <b-form-checkbox
                    v-model="visible_web"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'visible_web',visible_web)"
                  >
                </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Subscribes to Newsletter" label-cols="5">
                  <b-form-checkbox
                    v-model="newsletter"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'newsletter',newsletter)"
                  >
                </b-form-checkbox>
                </b-form-group>
                <b-form-group class="ml-3" label="Subscribes to General e-mails" label-cols="5">
                  <b-form-checkbox
                    v-model="general_emails"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'general_emails',general_emails)"
                  >
                </b-form-checkbox>
                </b-form-group> 
                <b-form-group class="ml-3" label="Subscribes to Priority e-mails" label-cols="5">
                  <b-form-checkbox
                    v-model="priority_emails"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'priority_emails',priority_emails)"
                  >
                </b-form-checkbox>
                </b-form-group>                    
                <!--b-form-group class="ml-3" label="Test mode NETS" label-cols="4">
                  <b-form-checkbox
                    v-model="nets"
                    value="1"
                    value-unchecked="0"
                    class="form-control border-0"
                    @input="savefield('g_profile',consultant_id,'nets',nets)"
                  >
                  </b-form-checkbox>
                </b-form-group -->      
                <div v-if="consultant_id < 1" class="col-12 row mt-2 ml-3 pl-0 align-items-top">
                  <div class="col-4 ml-0 pl-0 mx-0 px-0">Send 'set password' e-mail</div>
                  <div class="col-7 px-0">
                    <b-form-checkbox
                      v-model="sendmail"
                      class="form-control border-0"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
                <div class="form-group col-12 mt-4">
                  <b-button 
                    v-if="consultant_id < 1" 
                    @click.prevent="consultant_create" 
                    class="mt-10"
                    variant="primary"
                  >
                    Save New User
                  </b-button>
                </div>
              </div>
            </div>
          </form>
          <div class="col-6">
            <div v-if="consultant_id > 0" class="form-inline form-group col-12">
              <span class="col-12 px-0 mx-0 pt-2 pb-4">Labels</span><br>
                <span v-bind:key="label.id" v-for="label in labels" :style="{ 'background': '#'+label.color}" class="mr-2 py-1 pl-2 pr-2 rounded">
                  {{ label.label }}
                  <span 
                    @click.stop.prevent="removelabel(label.id)"
                  >
                    <fa-icon name="trash-alt" />
                  </span>
                </span>
                <span 
                  v-show="addinglabel==0"
                  class="icon-plus pt-0 text-primary"
                  :class="labels.length==0?'pt-2':'pt-0'"
                  @click.stop.prevent="addlabel(consultant_id)"
                >
            </span>
            <b-input-group 
              v-show="addinglabel==consultant_id"
              small class="col-3 pl-0 ml-0 py-0 my-0"
            >
              <b-form-input
                small
                class="form-control-sm py-0"
                v-model="addinglabeltext"
                placeholder="Add label"
                type="text"
                @keyup.enter.prevent="saveaddlabel"
                @keyup.escape.prevent="addinglabel = 0"
                autocomplete="off"
                ref="addinglabel"
              >
              </b-form-input>
              <b-input-group-text class="py-0" slot="append">
                <b-btn
                  variant="link"
                  size="sm"
                  @click="addinglabel = 0"
                  class="p-0 i"
                >
                X
                </b-btn>
              </b-input-group-text>
            </b-input-group>
            </div>
          </div>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab v-if="consultant_id > 0" class="px-0 col-12 border-0" lazy>
        <template v-slot:title>
          <div class="col-12 text-center">
            Surveys
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
            <b-tabs content-class="mt-3">
              <b-tab>
                <template v-slot:title>
                  <fa-icon
                    name="rocket"
                    class="mr-1"
                  />Ongoing
                </template>
                <ConsultantSurveys surveytype="ongoing" />
              </b-tab>
              <b-tab lazy>
                <template v-slot:title>
                  <fa-icon
                    name="pen"
                    class="mr-1"
                  />Drafts
                </template>
                <ConsultantSurveys surveytype="drafts" />
              </b-tab>
              <b-tab title="Upcoming" lazy>
                <template v-slot:title>
                  <fa-icon
                    name="clock"
                    class="mr-1"
                  />Upcoming
                </template>
                <ConsultantSurveys surveytype="upcoming" />
              </b-tab>
              <b-tab title="Finished" lazy>
                <template v-slot:title>
                  <fa-icon
                    name="check"
                    class="mr-1"
                  />Completed     
                </template>           
                <ConsultantSurveys surveytype="finished" />
              </b-tab>
              <b-tab title="Deleted" lazy>
                <template v-slot:title>
                  <fa-icon
                    name="trash-alt"
                    class="mr-1"
                  />Deleted                 
                </template>
                <ConsultantSurveys surveytype="deleted" />
              </b-tab>
            </b-tabs>
        </b-card>
      </b-tab>
      <b-tab v-if="consultant_id > 0" class="px-0 col-12 border-0" lazy>
        <template v-slot:title>
          <div class="col-12 text-center">
            Invoices
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
        </b-card>
      </b-tab>
      <b-tab v-if="consultant_id > 0" class="px-0 col-12 border-0" lazy>
        <template v-slot:title>
          <div class="col-12 text-center">
            Certifications
          </div>  
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <b-table
            id="certifications"
            hover
            :items="certifications"
            :fields="certificationfields"
            :busy="loading"
          />
        </b-card>
      </b-tab>
      <b-tab v-if="consultant_id > 0" class="px-0 col-12 border-0" lazy>
        <template v-slot:title>
          <div class="col-12 text-center">
            Import status
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <b-table
            id="notimported"
            hover
            :items="notimported"
            :fields="notimportedfields"
            :busy="loading"
          >
            <template v-slot:cell(actions)="data">
              <span
                v-show="importinggroup!=data.item.old_id"
                class="mr-2"
                @click.prevent.stop="group_import(data.item.old_id)"
              >
                <fa-icon name="file-import" />
              </span>
              <span
                v-show="importinggroup==data.item.old_id"
              >
                <b-spinner variant="primary"></b-spinner>
              </span>
            </template>          
          </b-table>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import ConsultantSurveys from './ConsultantSurveys';
import { Datetime } from 'vue-datetime';
import axios from 'axios'
import { config } from '../../config';
const base_url = config.base_url;
const api_token = config.api_token;

const notimportedfields = [
  { key: "select", label: "", sortable: false },
  { key: "group_name", label: "Not Imported Groups", sortable: false },
  { key: "actions", label: "", sortable: false, tdClass: "col-1" },
];

export default {
  components: {
    ConsultantSurveys,
    Datetime,
  },
  name: 'Consultant',
  created() {
    this.loading = true;
    this.get_recertification_params();
    this.consultantgroups_get();
    this.countries_get();
    this.partners_get();
    this.tots_get();
    this.companies_get();
    this.consultantstatuses_get();
    this.consultant_get();
    this.certifications_get();
  },
  data: function() {
    return {
      gui_loaded: false,
      formok: false,
      mailok: null,
      family_name: '',
      family_name_valid: null,
      first_name: '',
      first_name_valid: null,
      old_email: '',
      email: '',
      email_valid: null,
      prefix_title: null,
      company_name: null,
      address_1: null,
      address_2: null,
      zip_code: null,
      city: null,
      url: null,
      telephone: '',
      i_name: '',
      i_name_valid: null,
      i_password: '',
      i_usergroups: [],
      certificate_number: '',
      certification_date: null,
      gdq_short: 0,
      i_2fa: 0,
      i_2fa_email: 0,
      osc: 0,
      aggregated_reports: 0,
      aggregated_full: 0,
      spotify: 0,
      nets: 0,
      country_id: 0,
      country_id_valid: null,
      countries: [],
      company_id: 0,
      company_id_valid: null,
      companies: [],
      var_number: '',
      consultantgroup_id: 0,
      partner_id: 0,
      partner_id_valid: null,
      partners: [],
      certified_by: null,
      certified_by_valid: null,
      tots: [],
      consultantstatus_id: 0,
      consultantstatuses: [],
      labels: [],
      addinglabel: 0,
      addinglabeltext: '',
      loading: false,
      saving: false,
      settingpassword: false,
      newpassword: '',
      updatingusergroups: false,
      sendmail: false,
      notimported: [],
      notimportedfields: notimportedfields,
      importinggroup: 0,
      allow_demographics: 0,
      anonymize_survey_on_close: 0,
      vat_number: '',
      visible_web: 0,
      newsletter: 0,
      general_emails: 1,
      priority_emails: 1,
      mailsent: 0,
      last_login: null,
      lastlogin_months: 0,
      gdq_recertification_months: 1000,
      gdq_recertification: false,
      certificationfields: [],
      certifications: [],
      consultantgroups:[],
    }
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },
    consultant_id: {
      get() {
        return this.$store.state.currentconsultant_id;
      },
    },
    usergroups: {
      get() {
        return this.$store.state.usergroups;
      }
    },
    emailinvalidfeedback() {
      if (this.email == '') { return "E-mail is invalid"; }
      // eslint-disable-next-line
      if (!this.parse_email(this.email)) {
        return "Incorrect e-mail format";
      }
      return "E-mail already exists";
    },
    current_id() {
      return this.consultant_id;
    }
  },
  methods: {
    certifications_get() {
      const filter = {
        user_id: {
          operator: '=', 
          value: this.consultant_id,
        }
      };
      this.$store.dispatch('records_readlist',{ table_name: 'g_certifications', filter} )
      .then((resp) => {
        this.certificationfields = resp.data.columns.map( r => ({ key: r.field_name, label: r.list_caption}))
        this.certifications = resp.data.result;
      });
    },
    async get_recertification_params() {
      await this.$store.dispatch('syspref_fetch',{ key: 'gdq_recertification_months' })
      .then((resp) => {
        this.gdq_recertification_months = resp.data.value;
      });
    },
    sendpasswordlink() {
      const filter = {
        email: {
          operator: '=',
          value: this.email,
        }
      };
      this.$store.dispatch('forgotpassword', { filter: filter })
      .then(() => {
        this.mailsent = 1;
      });
    },
    sendwelcomeemail() {
      this.$store.dispatch('profile_send_welcome_email', { user_id: this.consultant_id })
      .then(() => {
        this.mailsent = 2;
      });
    },

    async generate_certificate_number() {
      await this.$store.dispatch('profile_generate_certificate_number', { id: this.consultant_id })
      .then((resp) => {
        this.certificate_number = resp.data.certificate_number;
      });
    },
    parse_email(email) {
      if ( email !== undefined ) { return true; }
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase());
    },
    group_import(id) {
      this.importinggroup = id;
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return new Promise((resolve) => {
        axios.get(base_url+"/gdq_migration_import_group/?consultant_id="+this.consultant_id+"&old_group_id="+id)
        .then((resp) => {
          this.importinggroup = 0;
          this.consultant_get();
          this.notimported_get();
          resolve(resp);
        })                
      });
    },
    notimported_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return new Promise((resolve) => {
        axios.get(base_url+"/gdq_migration_consultant_notimported_get/?email="+this.email)
        .then((resp) => {
          if (resp.data.groups) {
            this.notimported = resp.data.groups.map((a) => {
              return {
                "id": a.id,
                "group_name": a.group_name,
                "import": 1,
                "old_id": a.old_id,
              }
            });
          }
          resolve(resp);
        })                
      });
    },
    savepassword() {
      this.savefield('i_user',this.consultant_id,'i_password',this.newpassword);
      this.settingpassword = false;
      this.newpassword = '';
    },
    setpassword(setting) {
      this.settingpassword = setting;
    },
    checkemail() {
      this.formok = true;
      this.mailok = true; 
      this.email_valid = true;
      if (this.email == '') {
        this.email_valid = false;
        this.formok = false;
        this.mailok = false;
      }
   
      if(!this.parse_email(this.email)) {
        this.email_valid = false;
        this.formok = false;
        this.mailok = false;
      }
      if (this.email != this.old_email) {
        //----------------------
        // Check if email exists
        //----------------------
        if (this.mailok) {
          var filteremail = this.email;
          var filter = {
            id: {
              operator: "<>",
              value: this.consultant_id,
            },
            email: {
              operator: "=",
              value: filteremail,
            }
          }
          this.$store.dispatch('user_email_check', {
            filter: filter,
          })
          .then((resp) => {
            if (resp.data.total > 0) {
              this.email_valid = false;
              this.formok = false;
              return this.formok;
            }
          });
        } else {
          return this.formok;
        }
      } else {
        return this.formok;
      }
    },
    checkform() {
      if (this.gui_loaded != true) {
        return true;
      }
      this.formok = true;
      this.mailok = true;
      this.family_name_valid = true;
      this.first_name_valid = true;
      this.email_valid = true;
      if (this.family_name == '') { 
        this.family_name_valid = false; 
        this.formok = false;
      }
      if (this.first_name == '') { 
        this.first_name_valid = false; 
        this.formok = false;
      }
      if (this.email == '') {
        this.email_valid = false;
        this.formok = false;
        this.mailok = false;
      } else {
        if (!this.parse_email(this.email)) {
          this.email_valid = false;
          this.formok = false;
          this.mailok = false;
        }
      }
      if (this.email != this.old_email) {
        //----------------------
        // Check if email exists
        //----------------------
        if (this.mailok) {
          var filteremail = this.email;
          var filter = {
            id: {
              operator: "<>",
              value: this.consultant_id,
            },
            email: {
              operator: "=",
              value: filteremail,
            }
          }
          this.$store.dispatch('user_email_check', {
            filter: filter,
          })
          .then((resp) => {
            if (resp.data.total > 0) {
              this.email_valid = false;
              this.formok = false;
              return this.formok;
            }
          });
        } else {
          return this.formok;
        }
      } else {
        return this.formok;
      }
      return this.formok;
    },
    saveusergroups: function() {
      if (this.consultant_id <= 0 || this.loading == true || this.updatingusergroups == true) { return }
      this.updatingusergroups = true;
      this.$store.dispatch('consultantusergroups_save', 
        { 
          consultant_id: this.consultant_id, 
          i_usergroups: this.i_usergroups 
        }
      )
      .then((resp) => {
        this.updatingusergroups = false;
        return resp;
      });
    },
    consultant_create: function () {
      var check = this.checkform();
      if (check) {
        this.saving = true;
        var i_user = {
          family_name: this.family_name,
          first_name: this.first_name,
          email: this.email,
          i_email: this.email,
          i_name: this.i_name,
          i_password: this.newpassword,
          i_2fa: this.i_2fa,
          i_2fa_email: this.i_2fa_email,
        }
        this.$store.dispatch('user_create', { i_user: i_user })
        .then((resp) => {
           var user_id = resp.data.id;
           this.$store.dispatch('consultant_setcurrent',{ consultant_id: user_id })
           .then(() => {
            this.$store.dispatch(
              'profile_create',
              {    
                user_id: user_id,    
                profile: {    
                  prefix_title: this.prefix_title,
                  url: this.url,
                  telephone: this.telephone, 
                  certificate_number: this.certificate_number,
                  country_id: this.country_id,
                  consultantstatus_id: this.consultantstatus_id,
                  company_id: this.company_id,
                  vat_number: this.vat_number,
                  consultantgroup_id: this.consultantgroup_id,
                  partner_id: this.partner_id,
                  certified_by: this.certified_by,
                  certification_date: this.format_date(this.certification_date),
                  gdq_short: this.gdq_short,
                  osc: this.osc,
                  aggregated_reports: this.aggregated_reports,
                  aggregated_full: this.aggregated_full,
                  spotify: this.spotify,
                  nets: this.nets,
                  visible_web: this.visible_web,
                  newsletter: this.newsletter,
                  general_emails: this.general_emails,
                  priority_emails: this.priority_emails,
                  sendmail: this.sendmail,
                }
              }
            )
            .then(() => {
              //-----------------------------
              // Here save i_usergroup stuffs
              //-----------------------------
              this.mailok = null;
              this.updatingusergroups = true;
              this.$store.dispatch('consultantusergroups_save',
                {
                  consultant_id: this.consultant_id,
                  i_usergroups: this.i_usergroups
                }
              )
                .then(() => {
                  this.updatingusergroups = false;
                  this.consultant_get();
                  this.saving = false;
                });
             });
          });
        })
      } else {
        alert('Error saving');
      }
    },
    savefield(tablename,id,fieldname,value) {
      if (!this.loading) {
        if (fieldname === 'certification_date') {
          value = this.certification_date;
        }
        if (fieldname.indexOf('_date') != -1) {
          value = this.format_date(value);
        }
        if ( id > 0 ) { 
          if (this.checkform()) {
            var record = {
              id: id,
              [fieldname]: value,
            }
            this.$store.dispatch('field_save', { tablename: tablename,record: record })
            .then(() => {
              if (tablename == 'i_user' && fieldname == 'i_2fa' && value == 0) {
                this.$store.dispatch('field_save', { tablename: tablename,record: { id: id, i_2fa_secret: '' } })
              }
              this.$store.dispatch('consultantchanged_set',{ consultant_id: this.consultant_id });
            });
          }
        }
      }
    },
    tots_get () {
      this.$store.dispatch('tots_fetch')
      .then((resp) => {
        this.tots = [];
        this.tots.push({
          value: 0,
          text: '',
        });
        for (var i=0;i<resp.data.result.length;i++) {
          var totoption = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].name + ' - '+resp.data.result[i].email,
          }
          this.tots.push(totoption);
        }
      });
    },
    countries_get() {
      this.$store.dispatch('countries_fetch')
      .then((resp) => {
        this.countries = [];
        for (var i=0;i<resp.data.result.length;i++) {
          var countryoption = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].country_name,
          }
          this.countries.push(countryoption);
        }
      });
    },
    companies_get() {
      this.$store.dispatch('companies_fetch',{
        filter: '',
        start: 1,
        limit: 999999,
        orderby: 'company_name',
        order: 'ASC',
      })
      .then((resp) => {
        this.companies = [];
        this.companies.push({
          value: 0,
          text: '',
        });
        for (var i=0;i<resp.data.result.length;i++) {
          var companyoption = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].company_name,
          }
          this.companies.push(companyoption);
        }
      });
    },
    consultantgroups_get() {
      this.$store.dispatch('records_readlist',{ table_name: 'g_consultantgroups' })
      .then((resp) => {
        let consultantgroups = resp.data.result.map( r => ({ value: r.id, text: r.consultantgroup_name }));
        consultantgroups.unshift({ value: 0, text: '- no consultant group -'});
        this.consultantgroups = consultantgroups;
      });
    },
    partners_get() {
      this.$store.dispatch('partners_fetch',{
        filter: '',
        start: 1,
        limit: 999999,
        orderby: 'partner_name',
        order: 'ASC',
      })
      .then((resp) => {
        this.partners = [];
        this.partners.push({
          value: 0,
          text: '',
        });
        for (var i=0;i<resp.data.result.length;i++) {
          var partneroption = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].partner_name,
          }
          this.partners.push(partneroption);
        }
      });
    },
    consultantstatuses_get() {
      this.$store.dispatch('consultantstatuses_fetch',{
        filter: {
          consultantstatus_name: {
            operator: '<>',
            value: '',
          },
        },
        start: 1,
        limit: 999999,
        orderby: 'id',
        order: 'ASC',
      })
      .then((resp) => {
        this.consultantstatuses = [];
        for (var i=0;i<resp.data.result.length;i++) {
          var consultantstatus = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].consultantstatus_name,
          }
          this.consultantstatuses.push(consultantstatus);
        }
      });
    },
    consultantusergroups_get() {
      this.$store.dispatch('consultantusergroups_fetch', { consultant_id: this.consultant_id })
      .then((resp) => {
        this.i_usergroups = resp.data.groups;
      });
    },
    async consultant_get() {
      this.loading = false;
      this.family_name = '';
      this.first_name = '';
      this.email = '';
      this.old_email = '';
      this.telephone = '';
      this.prefix_title = '';
      this.company_name = '';
      this.address_1 = '';
      this.address_2 = '';
      this.zip_code = '';
      this.city = '';
      this.url = '';
      this.i_name = '';
      this.i_password = '';
      this.country_id = 0;
      this.consultantstatus_id = 0;
      this.company_id = 0;
      this.company_name = '';
      this.vat_number = '';
      this.consultantgroup_id = 0;
      this.partner_id = 0;
      this.certified_by = 0;
      this.certificate_number = '';
      this.certification_date = null;
      this.gdq_short = 0;
      this.osc = 0;
      this.aggregated_reports = 0;
      this.aggregated_full = 0;
      this.spotify = 0;
      this.nets = 0;
      this.visible_web = 0;
      this.newsletter = 0;
      this.general_emails = 1;
      this.priority_emails = 1;
      this.allow_demographics = 0;
      this.anonymize_survey_on_close = 0;
      this.lastlogin = null;
      this.i_2fa = 0;
      this.i_2fa_email = 0;
      this.labels = [];
      this.loading = true;
      if (this.consultant_id > 0) {
        await this.$store.dispatch('consultant_fetch', { consultant_id: this.consultant_id })
        .then((resp) => {
          this.gdq_recertification = false;
          this.lastlogin_months = 0; 
          if (resp.data.last_login !== null) {
            const d1 = new Date(resp.data.last_login.replace(' ','T'));
            const d2 = new Date();
            let months = 0;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth() + 1;
            months += d2.getMonth() + 1;
            this.lastlogin_months = months;
          } else {
            if (resp.data.certification_date !== null) {
              const d1 = new Date(resp.data.certification_date.replace(' ','T'));
              const d2 = new Date();
              let months = 0;
              months = (d2.getFullYear() - d1.getFullYear()) * 12;
              months -= d1.getMonth() + 1;
              months += d2.getMonth() + 1;
              this.lastlogin_months = months            
            }
          }
          // console.log(`Last login: ${this.lastlogin_months}, ${this.gdq_recertification_months || 1000}`)
          if (parseInt(this.lastlogin_months) > parseInt(this.gdq_recertification_months)) {
            this.gdq_recertification = true;
          }
          this.first_name = resp.data.first_name;
          this.family_name = resp.data.family_name;
          this.email = resp.data.email;
          this.old_email = resp.data.email;
          this.telephone = resp.data.telephone;
          this.prefix_title = resp.data.prefix_title;
          this.company_name = resp.data.company_name;
          this.address_1 = resp.data.address_1;
          this.address_2 = resp.data.address_2;
          this.zip_code = resp.data.zip_code;
          this.city = resp.data.city;
          this.url = resp.data.url;
          this.i_name = resp.data.i_name;
          this.country_id = resp.data.country_id;
          this.consultantstatus_id = resp.data.consultantstatus_id;
          this.company_id = resp.data.company_id;
          this.company_name = resp.data.company_name;
          this.vat_number = resp.data.vat_number;
          this.consultantgroup_id = resp.data.consultantgroup_id;
          this.partner_id = resp.data.partner_id;
          this.certified_by = resp.data.certified_by;
          this.certificate_number = resp.data.certificate_number;
          this.certification_date = resp.data.certification_date;
          this.gdq_short = resp.data.gdq_short;
          this.osc = resp.data.osc;
          this.aggregated_reports = resp.data.aggregated_reports;
          this.aggregated_full = resp.data.aggregated_full;
          this.spotify = resp.data.spotify;
          this.nets = resp.data.nets;
          this.visible_web = resp.data.visible_web;
          this.newsletter = resp.data.newsletter;
          this.general_emails = resp.data.general_emails;
          this.priority_emails = resp.data.priority_emails;
          this.allow_demographics = resp.data.allow_demographics;
          this.anonymize_survey_on_close = resp.data.anonymize_survey_on_close;
          this.i_2fa = resp.data.i_2fa;
          this.i_2fa_email = resp.data.i_2fa_email;
          this.last_login = resp.data.last_login;
          this.labels = resp.data.labels;
          this.checkform();
          this.$store.dispatch('consultantusergroups_fetch', { consultant_id: this.consultant_id })
          .then((resp) => {
            this.i_usergroups = resp.data.groups;
            this.loading = false;
            this.gui_loaded = true;
            this.notimported_get();
          });
        })
      }
    },
    backtolist() {
      this.$store.dispatch('consultant_setcurrent',{ consultant_id: 0 })
    },
    conslabels_get() {
      this.$store.dispatch('consultant_fetch', { consultant_id: this.consultant_id })
      .then((resp) => {
        this.labels = resp.data.labels;
      });
    },
    saveaddlabel() {
      if (this.addinglabeltext != '') {
        var savelabel = {
          consultant_id: this.addinglabel,
          label: this.addinglabeltext,
        }
        this.$store.dispatch('consultantlabel_add', { label: savelabel })
        .then(()=> {
          this.conslabels_get();
          this.$store.dispatch('consultantlabelchanged_set', { consultant_id: this.consultant_id });
        });
      }
      this.addinglabel = 0;
      this.addinglabeltext = '';
    },
    addlabel(id) {
      this.addinglabel = id;
      this.addinglabeltext = '';
      this.$nextTick(() => this.$refs.addinglabel.focus())
    },
    removelabel(consultantlabel_id) {
      this.$store.dispatch('consultantlabel_delete', { id: consultantlabel_id })
      .then(()=> {
        this.conslabels_get();
        this.$store.dispatch('consultantlabelchanged_set', { consultant_id: this.consultant_id });
      });
    },
    //=================
    // HELPER FUNCTIONS
    //=================
    format_date(date) {
      var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
      if (isNaN(year)) { return ''; }
      if (Number.isNaN(month)) { return ''; }
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    },
    format_time(date) {
      if (date.length == 5) {
        return date;
      }
      var d = new Date(date);
      var h = d.getHours();
      var m = d.getMinutes();
      var hour = (h>9?'':'0')+h;
      var minute = (m>9?'':'0')+m;
      var thistime = hour+':'+minute;
      return thistime;
    },
  }
}
</script>